/* eslint-disable react/prop-types */
import React from 'react';
import Navigation from 'components/Navigation';
class Redirect extends React.Component {
  render() {
    const data = this.props.dataItems[this.props.name];

    return (
      <div className="fadeIn flex flex-col justify-between">
        <div className="flex flex-1 items-center">
          <div className="flex column border border-solid border-xborder rounded-2xl items-center gap-4 min-w-full p-6 bg-white">
            {data.image && (
              <img
                className="max-w-80"
                src={data.image}
                alt="L'énergie au coeur de votre projet"
              />
            )}
            {data.text && (
              <p
                className="text-[20px] leading-[20px] text-center text-bleu-hellio"
                dangerouslySetInnerHTML={{
                  __html: data.text,
                }}
              />
            )}
            {data.subText && (
              <p
                className="text-[16px] leading-[24px] text-center text-gris-hellio"
                dangerouslySetInnerHTML={{
                  __html: data.subText,
                }}
              />
            )}
          </div>
        </div>

        <Navigation
          data={true}
          step={this.props.step}
          nextStep={() => window.open(data.redirect, '_blank')}
          lastStep={this.props.lastStep}
          loadingParcours={this.props.loadingParcours}
          leadsource={this.props.leadsource}
          lastStepPrequestion={this.props.lastStepPrequestion}
        />
      </div>
    );
  }
}

export default Redirect;
